import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { options } from 'config/reactRedux';
import { LANGUAGE, LANGUAGES } from 'config/types/prop';
import withStyles from 'isomorphic-style-loader/withStyles';
import I18n from 'components/i18n';
import icons from 'config/icons';
import { buildCTALink } from 'utils/url';
import isNode from 'utils/environment';
import isDesktop from 'utils/isDesktop';

import FlagLanguageItem from '../flagLanguageItem';
import styles from '../languagePicker.css';
import condensedStyles from './condensed.css';
import { numberOfVisibleFlags } from '../numberOfVisibleFlags';

class LanguagePickerCondensed extends Component {
  constructor(props) {
    super(props);
    this.scrollElement = null;

    this.state = {
      isShadowLeft: false,
      isShadowRight: false,
    };
  }

  componentDidMount() {
    this.setShadowOverlay();
  }

  componentDidUpdate(prevProps) {
    const arePropsChanged =
      this.props.languages.length !== prevProps.languages.length ||
      this.props.languages.some((language, index) =>
        language.url !== prevProps.languages[index].url,
      );
    if (arePropsChanged) {
      this.setShadowOverlay();
    }
  }

  setShadowOverlay = () => { // eslint-disable-line react/sort-comp
    if (this.isFullyScrolledLeft()) {
      this.setState({ isShadowLeft: false });
    } else if (!this.state.isShadowLeft) {
      this.setState({ isShadowLeft: true });
    }

    if (this.isFullyScrolledRight()) {
      this.setState({ isShadowRight: false });
    } else if (!this.state.isShadowRight) {
      this.setState({ isShadowRight: true });
    }
  };

  onScrollContainer = this.setShadowOverlay;

  setScrollElementRef = (scrollElement) => {
    this.scrollElement = scrollElement;
  };

  isFullyScrolledLeft = () => 0 === this.scrollElement.scrollLeft;

  isFullyScrolledRight = () => {
    const { clientWidth, scrollLeft, scrollWidth } = this.scrollElement;
    return scrollLeft + clientWidth === scrollWidth;
  };

  render() {
    const { currentEdition, getTranslation, isSticky, languages } = this.props;
    const showingLanguages = isDesktop ? languages.slice(0, numberOfVisibleFlags) : languages;
    const goLink = buildCTALink(currentEdition);
    const seeMoreText = getTranslation('masthead-more', 'More...');

    return (
      <div className={classNames(
        condensedStyles.wrapper,
        styles.condensed,
        { [condensedStyles.sticky]: isSticky },
      )}
      >
        <div className={condensedStyles.innerContainer}>
          <div className={classNames(
            condensedStyles.shadowLeft, {
              [condensedStyles.visible]: this.state.isShadowLeft,
            })}
          />
          <div className={classNames(
            condensedStyles.shadowRight, {
              [condensedStyles.visible]: this.state.isShadowRight,
            })}
          />
          <header className={condensedStyles.header}>
            <div className={condensedStyles.heading}>
              <I18n
                field="pick-a-language-to-learn"
                defaultText="Pick a Language to Learn"
              />
              <img
                alt="Right Arrow"
                className={condensedStyles.rightArrow}
                src={icons.rightArrow}
                height="7.83"
                width="18"
              />
            </div>
          </header>
          <div
            className={condensedStyles.inner}
            onScroll={this.onScrollContainer}
            ref={this.setScrollElementRef}
          >
            {!isNode() &&
              <ul className={classNames(
                styles.list,
                styles.listCondensed,
              )}
              >
                {showingLanguages.map((item) => (
                  <li
                    key={`${item.text}${item.url}`}
                    className={condensedStyles.item}
                  >
                    <FlagLanguageItem
                      {...item}
                      styles={condensedStyles}
                    />
                  </li>
                ))}
                {isDesktop &&
                  <li className={condensedStyles.item}>
                    <FlagLanguageItem
                      flag="plus"
                      url={goLink}
                      styles={condensedStyles}
                      text={seeMoreText}
                      isCircle
                      hasPlus
                    />
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      </div>
    );
  }
}

LanguagePickerCondensed.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape(LANGUAGE),
  ).isRequired,
  currentEdition: LANGUAGES.isRequired,
  getTranslation: PropTypes.func.isRequired,
  isSticky: PropTypes.bool,
};

LanguagePickerCondensed.defaultProps = {
  isSticky: false,
};

const wrapWithStyles = withStyles(styles, condensedStyles);

export default wrapWithStyles(LanguagePickerCondensed);
